import { render, staticRenderFns } from "./FeatureListTable.vue?vue&type=template&id=c058ed84&scoped=true"
import script from "./FeatureListTable.vue?vue&type=script&lang=js"
export * from "./FeatureListTable.vue?vue&type=script&lang=js"
import style0 from "./FeatureListTable.vue?vue&type=style&index=0&id=c058ed84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c058ed84",
  null
  
)

export default component.exports